import{inBrowser as o}from"./dom.js";function t(t){var a,i=void 0===t?{}:t,e=i.pageTitle,d=i.appTitle;o()&&(document.title=null!==(a=(e?e+" - ":"")+d)&&void 0!==a?a:"Canada.ca")}export{t as setDocumentTitle};
//# sourceMappingURL=page-meta.js.map
